import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import UploadFileModal from '../modals/uploadFileModal';
// import TemplateStylingModal from '../modals/templateStylingModal';
// import TemplateQuestionsModal from '../modals/templateQuestionsModal';
import RefreshIcon from '@/components/icons/refreshIcon';
import bin from '@/assets/images/bin.svg';
import add from '@/assets/images/add.svg';
// import edit from '@/assets/images/edit.svg';
// import questions from '@/assets/images/questions.svg';

export default function TemplateCard(props) {
  const {
    handleNextStepClick,
    handlePreviousStepClick,
    handleSelectedTemplateChange,
    templates = [],
    selectedTemplate,
    handleRefreshTemplates,
    selectedRole,
    deleteTemplate,
    isLoading
  } = props;

  // const apiUrl = process.env.REACT_APP_API_URL;
  // const apiKey = process.env.REACT_APP_API_KEY;

  const [attachment, setAttachment] = useState(null);
  const [modalState, setModalState] = useState(false);
  const [template, setTemplate] = useState(null);
  // const [stylingModalState, setStylingModalState] = useState(false);
  // const [templateStylingData, setTemplateStylingData] = useState(null);
  // const [questionsModalState, setQuestionsModalState] = useState(false);
  // const [templateQuestionsData, setTemplateQuestionsData] = useState(null);
  // const [selectedTemplateId, setSelectedTemplateId] = useState(null); // New state to track selected template ID

  const handleAttachmentChange = (e) => {
    const selectedAttachment = e.target.files && e.target.files.length > 0 ? e.target.files[0] : null;
    setAttachment(selectedAttachment);
  };

  const handleSelectFile = (selected) => {
    handleSelectedTemplateChange(selected);
    setTemplate(selected);
  };

  const handleToggleModalState = () => {
    setModalState(!modalState);
  };

  // const handleToggleTemplateStylingModal = (templateId) => {
  //   if (!stylingModalState) {
  //     setSelectedTemplateId(templateId); // Set the selected template ID
  //   } else {
  //     setTemplateStylingData(null);
  //   }
  //   setStylingModalState(!stylingModalState);
  // };

  const handleSetSelected = (selected) => {
    setTemplate(selected);
    handleSelectedTemplateChange(selected);
  };

  // const handleFetchStyling = async (templateId) => {
  //   console.log('template id', templateId);
  //   try {
  //     const result = await fetch(`${apiUrl}/formatter/template/styling/${templateId}`, {
  //       method: "GET",
  //       headers: {
  //         "x-api-key": `${apiKey}`,
  //         "Content-Type": "application/json",
  //       },
  //       mode: 'cors',
  //     });
  //     const data = await result.json();
  //     console.log('questions', data.data.data)
  //     return data.data.data;
  //   } catch (error) {
  //     console.log('error', error);
  //     return null;
  //   }
  // };

  // // useEffect to fetch styling data when modal is opened
  // useEffect(() => {
  //   const fetchData = async () => {
  //     if (stylingModalState && selectedTemplateId) {
  //       const response = await handleFetchStyling(selectedTemplateId);
  //       if (response) {
  //         setTemplateStylingData(response);
  //       }
  //     }
  //   };

  //   fetchData();
  // }, [stylingModalState, selectedTemplateId]);

  // // useEffect to log the templateStylingData when it changes
  // useEffect(() => {
  //   if (templateStylingData) {
  //     console.log('Updated templateStylingData', templateStylingData); // Log the updated data
  //   }
  // }, [templateStylingData]);

  // const handleToggleTemplateQuestionsModal = (templateId) => {
  //   if (!questionsModalState) {
  //     setSelectedTemplateId(templateId); // Set the selected template ID
  //   } else {
  //     setTemplateQuestionsData(null);
  //   }
  //   setQuestionsModalState(!questionsModalState);
  // };

  return (
    <section className="template">
      <div className="template__inner">
        <div className="card-heading">
          <div className="text-div">
            <h4 className="title">Select A Template <RefreshIcon onClick={handleRefreshTemplates} /></h4>
          </div>
        </div>
        <ul className="template-list">
          {isLoading === true && <li className="spinner"><div className="lds-dual-ring"></div></li>}
          {isLoading === false && templates.map((element, index) => (
            <li onClick={() => handleSelectFile(element)} key={index} className={selectedTemplate === element ? 'selected' : ''}>
              <div className="options">
                <button className="option-button" onClick={() => deleteTemplate(element)}>
                  <img className="bin" alt="Delete" src={bin} />
                </button>
                {/* <button className="option-button" onClick={() => handleToggleTemplateStylingModal(element.id)}>
                  <img className="bin" alt="Edit Template Styling" src={edit} />
                </button> */}
                {/* <button className="option-button" onClick={() => handleToggleTemplateQuestionsModal(element.id)}>
                  <img className="bin" alt="Edit" src={questions} />
                </button> */}
              </div>
              <div className="template-name">{element.filename}</div>
              <div className="spinner-div"><div className="lds-dual-ring"></div></div>
            </li>
          ))}
        </ul>

        <div className="add-button-div">
          <button className="add-template" onClick={handleToggleModalState}><img src={add} alt="Add a New Role" /></button>
        </div>

        {modalState && (
          <UploadFileModal
            handleToggleModalState={handleToggleModalState}
            parentModalState={modalState}
            /* stylingModalState={stylingModalState} */
            handleSelectFile={handleSelectFile}
            type="template"
            handleRefresh={handleRefreshTemplates}
            selectedRole={selectedRole}
            isLoading={isLoading}
            file={template}
            /* handleToggleTemplateStylingModal={handleToggleTemplateStylingModal} */
            handleSetSelected={handleSetSelected}
          />
        )}

        {/* {stylingModalState && templateStylingData && (
          <TemplateStylingModal
            handleToggleTemplateStylingModal={handleToggleTemplateStylingModal}
            selectedTemplate={selectedTemplate}
            template={template}
            templateStylingData={templateStylingData}
          />
        )} */}

        {/* {questionsModalState && (
          <TemplateQuestionsModal
            handleToggleTemplateQuestionsModal={handleToggleTemplateQuestionsModal}
            selectedTemplate={selectedTemplate}
            templateQuestionsData={templateQuestionsData}
            questionsModalState={questionsModalState}
          />
        )} */}
      </div>
    </section>
  );
}
